import axios from "axios";

axios.defaults.withCredentials = true;

axios.defaults.headers = {
    Accept: "application/json",
    "Access-Control-Allow-Credentials": true,
    "X-Requested-With": "XMLHttpRequest"
};

export default axios;
